import { MorphemeMnemonicsPanelContextProvider } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.mnemonics._components.panel-content._context";
import {
  GraphemeMorphemePanelsContext,
  MorphemePanelsContext,
} from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._context";
import { usePrevalentPinyin } from "@-/dev.improve.haniverse.routes.nav.app._lib.morpheme.grapheme.pinyin.prevalence";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import type { PropsWithChildren } from "react";
import { hasLength } from "@-/com.npmjs.ts-array-length";
import arrayLength from "@-/com.npmjs.extra-array__length";

export function MorphemeMnemonicsPanelContentRoot({
  advancePronunciationRequestId = 0,
  children,
  hidePronunciationTabs = false,
}: PropsWithChildren<{
  advancePronunciationRequestId?: number;
  hidePronunciationTabs?: boolean;
}>) {
  const [front, pinyinList] = useContextSelectors(
    GraphemeMorphemePanelsContext,
    (c) => c.readonlySlice.data.grapheme,
    (c) => c.readonlySlice.data.pinyinList,
  );
  const [isFlashcardEditPending, onFlashcardEditPendingChange, onToolbarEditActionChange] =
    useContextSelectors(
      MorphemePanelsContext,
      (c) => c.isFlashcardEditPending,
      (c) => c.onFlashcardEditPendingChange,
      (c) => c.onToolbarEditActionChange,
    );
  const studyPinyinList = usePrevalentPinyin(front, pinyinList);
  const pinyinTabCount =
    hidePronunciationTabs || hasLength(studyPinyinList, 0) ? 0 : arrayLength(studyPinyinList);
  const tabCount = 1 + pinyinTabCount;

  return (
    <MorphemeMnemonicsPanelContextProvider
      advancePronunciationRequestId={advancePronunciationRequestId}
      grapheme={front}
      isFlashcardEditPending={isFlashcardEditPending}
      onFlashcardEditPendingChange={onFlashcardEditPendingChange}
      onToolbarEditActionChange={onToolbarEditActionChange}
      tabCount={tabCount}
    >
      {children}
    </MorphemeMnemonicsPanelContextProvider>
  );
}
